// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3lHxD","skeleton":"styles_skeleton__343Oq","image":"styles_image__1J5Eu","move":"styles_move__ZTLTh"};